import React, {useState} from "react";
import "./elearning-set-data-table.styles.scss";

import CustomButton from "../../commons/custom-button/custom-button.component";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import EmptyTableComponent from "../empty-component/empty-table-compontent";
import {getELearningList, getOldOrderHistory} from "../../../redux/clientdata/client.action";
import {createToken} from "../../../js/api/_azure-queue.data";
import {ClientServices} from "../../../redux/clientdata/client.services";
import ContentWell from "../../commons/content-well/content-well.component";
import removeStyleFromHTMLString from "../../../utilities/CommonUtilities";
import Parser from "html-react-parser";

function ElearningTableComponent({
                                     title,
                                     filterOne,
                                     filterTwo,
                                     tableItemsOne,
                                     tableItemsTwo,
                                     categoriesOne,
                                     categoriesTwo,
                                     tableOneColumnWidth = "210px",
                                     tableTwoColumnWidth = "210px",
                                 }) {
    const [tableColumnWidth, setTableColumnWidth] = useState(tableOneColumnWidth);
    const [activeDisplay, setAtiveDisplay] = useState(filterOne);
    const [tableCategories, setTableCategories] = useState(categoriesOne);
    const [tableItems, setTableItems] = useState(tableItemsOne);

    const eLearningList = useSelector(({client}) => client.eLearningList);
    const oldLearningList = useSelector(({client}) => client.oldLearning);

    const history = useHistory();
    const dispatch = useDispatch();
    const userEmailData = useSelector(({user}) => user.verified_email);
    const userMemberIdData = useSelector(({cart}) => cart.impersonateMember);

    React.useEffect(() => {
        dispatch(getELearningList(userMemberIdData.memberId));
        dispatch(getOldOrderHistory(userEmailData))
    }, []);

    const toggleDisplayOne = () => {
        setTableColumnWidth(tableOneColumnWidth);
        setAtiveDisplay(filterOne);
        setTableCategories(categoriesOne);
        setTableItems(tableItemsOne);
    };

    const toggleDisplayTwo = () => {
        setTableColumnWidth(tableTwoColumnWidth);
        setAtiveDisplay(filterTwo);
        setTableCategories(categoriesTwo);
        setTableItems(tableItemsTwo);
    };


    //TODO Implement download function
    const onOpenVideo = async (courseName, type) => {
        const token = await createToken();
        ClientServices.getELearningVideoURL(courseName, "elearning", token).then((url) => {
            // history.push('/client/playback', url)
            // console.log(url);
            window.open(url, "_blank")
        })
    };

    /*if (eLearningList.length === 0 && oldLearningList.length === 0) {
        return (<EmptyTableComponent message={"You do not have any e-learning courses"}/>);
    }*/

    let finalData = [...eLearningList, ...oldLearningList]

    console.log(finalData);

    return (
        <div className="elearning-table-account">
            <div className="trinity-container">

                <h2 className="d-lg-none">{title}</h2>
                {/*<div className="section-filters mt-3 mb-3">
                    <span className={`filter clickable ${activeDisplay === filterOne ? "bold" : ""}`}
                          onClick={toggleDisplayOne}>
                        {filterOne}
                    </span>

                    <span className="seperator ml-2 mr-2">|</span>

                    <span className={`filter clickable ${activeDisplay === filterTwo ? "bold" : ""}`}
                          onClick={toggleDisplayTwo}>
                        {filterTwo}
                    </span>
                </div>*/}
            </div>

            <div className="data-table-container">
                <div className="overflow-width-setter">
                    <div className="table-categories mb-3">
                        <div className="trinity-container d-flex fluid">
                            {tableCategories.map((category) => (
                                <h5
                                    key={category}
                                    style={{width: tableColumnWidth}}
                                    className="category column m-0">
                                    <span className="mr-2">{category}</span>
                                </h5>
                            ))}
                        </div>
                    </div>

                    {finalData && (
                        <div className="trinity-container">
                            <div className="table-items">
                                {
                                    finalData.length === 0 ? <h3>No Records Available.</h3>
                                        : finalData.map((item, i) => {
                                            // { customer_id, data, software, edition, version, released, activated, maintenance }
                                            return (
                                                <div key={Math.random() * 100 + i} className="table-item">
                                                    <div key={Math.random()} style={{width: tableColumnWidth}}
                                                         className="column">
                                                        {item.CourseName}
                                                    </div>
                                                    <div key={Math.random()} style={{width: tableColumnWidth}}
                                                         className="column">
                                                        {
                                                            item.CourseDescription &&
                                                            <ContentWell
                                                                content={removeStyleFromHTMLString(Parser(item.CourseDescription))}/>
                                                        }
                                                    </div>
                                                    <div key={Math.random()} style={{width: tableColumnWidth}}
                                                         className="column">
                                                        {item.CourseLength + " Hrs"}
                                                    </div>
                                                    <div className="column">
                                                        <CustomButton
                                                            onClick={() => onOpenVideo(item.CourseName, item.PaymentType)}>
                                                            Start Course
                                                        </CustomButton>
                                                    </div>
                                                </div>
                                            );
                                        })
                                }
                            </div>
                        </div>
                    )}

                    {/*{activeDisplay === filterTwo && oldLearningList && (
                        <div className="trinity-container">
                            <div className="table-items">
                                {
                                    oldLearningList.length === 0 ? <h3>No Records Available.</h3>
                                        : oldLearningList.map((item, i) => {
                                            // { customer_id, data, software, edition, version, released, activated, maintenance }
                                            return (
                                                <div key={Math.random() * 100 + i} className="table-item">
                                                    <div key={Math.random()} style={{width: tableColumnWidth}}
                                                         className="column">
                                                        {item.CourseName}
                                                    </div>
                                                    <div key={Math.random()} style={{width: tableColumnWidth}}
                                                         className="column">
                                                        <ContentWell content={removeStyleFromHTMLString(Parser(item.CourseDescription))}/>
                                                    </div>
                                                    <div key={Math.random()} style={{width: tableColumnWidth}}
                                                         className="column">
                                                        {item.CourseLength}
                                                    </div>
                                                    <div className="column">
                                                        <CustomButton
                                                            onClick={() => onOpenVideo(item.CourseName, item.PaymentType)}>Start
                                                            Course</CustomButton>
                                                    </div>
                                                </div>
                                            );
                                        })}
                            </div>
                        </div>
                    )}*/}
                </div>
            </div>
        </div>
    );
}

export default ElearningTableComponent;
